"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_link_1 = require("apollo-link");
var debug_1 = __importDefault(require("debug"));
var log = debug_1.default('graphql.auth');
/**
 * Returns ApolloLink instance used for attaching Authorization header to context.
 * Invokes options.getToken that should return token to be used. Value is cached.
 * Use options.shouldInvalidate callback to inform if token should be retrieved again.
 *
 * Set context.overrideWithToken to use different token for this operation.
 * Set context.invalidateWithToken to replace previously cached token with specified one.
 *
 * @param options IOptions
 */
function createAuthLink(_a) {
    var getToken = _a.getToken, _b = _a.enableTokenCache, enableTokenCache = _b === void 0 ? true : _b, _c = _a.canCommunicate, canCommunicate = _c === void 0 ? function () { return true; } : _c, onInvalidToken = _a.onInvalidToken;
    var tokenPromise;
    var invalidateCachedToken = function () {
        tokenPromise = null;
    };
    var getTokenOnce = function (context) {
        if (context.overrideWithToken) {
            log('overriding with token');
            return Promise.resolve(context.overrideWithToken);
        }
        if (context.invalidateWithToken) {
            log("invalidating with token " + context.invalidateWithToken);
            tokenPromise = Promise.resolve(context.invalidateWithToken);
        }
        else if (!(tokenPromise && enableTokenCache)) {
            tokenPromise = Promise.resolve(getToken());
        }
        return tokenPromise;
    };
    return new apollo_link_1.ApolloLink(function (operation, forward) {
        if (canCommunicate(operation) !== true) {
            log("communication blocked for operation " + operation.operationName);
            return null;
        }
        return new apollo_link_1.Observable(function (observer) {
            var handle;
            var context = operation.getContext();
            getTokenOnce(context).then(function (token) {
                var prevHeaders = context.headers || {};
                var headers = __assign(__assign({}, prevHeaders), { Authorization: "Bearer " + token });
                operation.setContext(__assign(__assign({}, context), { headers: headers,
                    token: token }));
                handle = forward(operation).subscribe({
                    error: function (networkError) {
                        if (networkError.result &&
                            networkError.result.code === 'INVALID_TOKEN') {
                            log('invalidating token based on server response');
                            if (onInvalidToken) {
                                onInvalidToken();
                            }
                            invalidateCachedToken();
                            return;
                        }
                        observer.error(networkError);
                    },
                    next: observer.next.bind(observer),
                    complete: observer.complete.bind(observer),
                });
            });
            return function () {
                if (handle) {
                    handle.unsubscribe();
                }
            };
        });
    });
}
exports.createAuthLink = createAuthLink;
function fetchGuestToken(endpoint) {
    return __awaiter(this, void 0, void 0, function () {
        var url, options, response, _a, token, userId;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    url = endpoint + "/users/token?guest=true";
                    options = {
                        headers: {
                            Accept: 'application/json',
                        },
                    };
                    return [4 /*yield*/, fetch(url, options)];
                case 1:
                    response = _b.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a = _b.sent(), token = _a.token, userId = _a.userId;
                    return [2 /*return*/, { token: token, userId: String(userId) }];
            }
        });
    });
}
exports.fetchGuestToken = fetchGuestToken;
//# sourceMappingURL=createAuthLink.js.map